import { Component, OnInit } from '@angular/core';
import { ReasonService } from '../../services/reason.service';
import { MemberAccessReason } from '../../models/member-access-reason.model';
import { MatDialog } from '@angular/material';
import { ReasonDialogComponent } from './reason-dialog/reason-dialog.component';


@Component({
  selector: 'reason',
  template: require('./reason.component.html'),
  styles: [require('./reason.component.css')]
})
export class ReasonComponent implements OnInit {

    memberAccessReasons: MemberAccessReason[] = [];
    loadingIndicator: boolean = false;

    constructor( private memberAccessReasonService : ReasonService, public dialog: MatDialog) { }

    ngOnInit() {
        this.getAllMemberAccessReason();
    }

    getAllMemberAccessReason() {
        this.memberAccessReasons.length = 0;
        this.loadingIndicator = true;
        this.memberAccessReasonService.getAllMemberAccessReason().subscribe(r => {
            this.loadingIndicator = false;
            this.memberAccessReasons = r;
            console.log(this.memberAccessReasons)
      })

    }


    createReason() {

        let dialogRef = null;
        dialogRef = this.dialog.open(ReasonDialogComponent, {
            panelClass: 'col-sm-6',
            data: {
                reason: {} as MemberAccessReason
            },
            disableClose:true
        })
    }


    updateOrCreateReason(memberAccessReason? : any) {
        let dialogref;
        dialogref = this.dialog.open(ReasonDialogComponent, {
            panelClass: 'col-sm-6',
            data: {
                reason: memberAccessReason
            },
            disableClose: true
            
        })


        dialogref.afterClosed().subscribe(r => {
            if (r) {
                this.getAllMemberAccessReason();
            }
        })
    }

    deleteReason(memberAccessReason) {
        let dialogref;
        dialogref = this.dialog.open(ReasonDialogComponent, {
            panelClass: 'col-sm-4',
            data: {
                reason: memberAccessReason,
                isDelete: true,
            },
            disableClose: true

        })


        dialogref.afterClosed().subscribe(r => {
            if (r) {
                console.log('delete')
                this.getAllMemberAccessReason();
            }
        })
    }
}



// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./ClientApp/app/components/reason/reason.component.ts